import { FormalityStateType } from './types';

export const ordersSelector = (s: FormalityStateType) => s.formalites.orders.main;

export const FormalitySelector = (s: FormalityStateType) => s.formalites.formalities;
export const formalitiesSelector = (s: FormalityStateType) => s.formalites.formalities.main;

export const categoriesFormalitySelector = (s: FormalityStateType) =>
    s.formalites.categories_formalites.main;

export const DossierFormaliteSelector = (s: FormalityStateType) => s.formalites.dosform.main;
export const DossierOpenSearchSelector = (s: FormalityStateType) => s.formalites.dossiersOpenSearch;
export const DossierOpenSearchSelectorMain = (s: FormalityStateType) =>
    s.formalites.dossiersOpenSearch.main;
export const DossierOpenSearchPrescriberSelector = (s: FormalityStateType) =>
    s.formalites.dossiersOpenSearchPrescriber;
export const DossierOpenSearchPrescriberSelectorMain = (s: FormalityStateType) =>
    s.formalites.dossiersOpenSearchPrescriber.main;
export const CollectionOpenSearchSelector = (s: FormalityStateType) =>
    s.formalites.ordersOpenSearch;
export const CollectionOpenSearchSelectorMain = (s: FormalityStateType) =>
    s.formalites.ordersOpenSearch.main;

export const legalStatusSelector = (s: FormalityStateType) => s.formalites.legalStatuses.main;
export const formalitiesDocumentSelector = (s: FormalityStateType) =>
    s.formalites.formaliteDocuments.main;
export const formalistesSelector = (s: FormalityStateType) => s.formalites.formalistes.main;
export const dossierStepsSelector = (s: FormalityStateType) => s.formalites.dossierSteps.main;
export const statusesSelector = (s: FormalityStateType) => s.formalites.statuses.main;
export const dossierObjectGroupSelector = (s: FormalityStateType) =>
    s.formalites.dossierObjectGroup.main;
export const dossierOpenSearchObjectGroupSelector = (s: FormalityStateType) =>
    s.formalites.dossierOpenSearchObjectGroup.main;
export const dossierValidatorsSelector = (s: FormalityStateType) =>
    s.formalites.dossierValidators.main;
export const dossierTachesSelector = (s: FormalityStateType) => s.formalites.dossierTaches.main;
export const dossierLogActionSelector = (s: FormalityStateType) =>
    s.formalites.dossierLogAction.main;
